import React, { useState } from 'react'
import StarsIcon from '@mui/icons-material/Stars';
import "../styles/Navbar.css"
import { Link, animateScroll as scroll } from 'react-scroll';
import MenuIcon from '@mui/icons-material/Menu';
const dur = 10
const off = -50

const Navbar = () => {
  const [showNavs, setShowNavs] = useState(false)
    function openGithub(e){
        window.open("https://github.com/praneethNellutla")
    }
    function mobileMenuView(e){
      setShowNavs(showNavs => showNavs ? false : true)
    }
    function scrollToTop(e) {
      scroll.scrollToTop();
    }

  return (
    <nav className='navHeader'>
        <div className='main' onClick={scrollToTop}>
          <StarsIcon />
          <h1>Portfolio</h1>
        </div>
      <div className='mobileMenu'>
        <MenuIcon onClick={mobileMenuView}/>
      </div>
      <div className="desktopNavLinks">
        <span className='navs'> <Link activeClass='active' to="about" spy={true} offset={off} duration={dur} > About </Link> </span>
        <span className='navs'> <Link activeClass='active' to="skills" spy={true}  offset={off} duration={dur} > Skills </Link> </span>
        <span className='navs'> <Link activeClass='active' to="experience" spy={true}  offset={off} duration={dur} > Experience </Link> </span>
        <span className='navs'> <Link activeClass='active' to="projects" spy={true}  offset={off} duration={dur} > Projects </Link> </span>
        <span className='navs'> <Link activeClass='active' to="education" spy={true} offset={off} duration={dur} > Education </Link> </span>
        <span className='navs'> <Link activeClass='active' to="contact" spy={true} offset={off} duration={dur} > Contact </Link> </span>
      </div>
      <span className='githubLink' onClick={openGithub}>Github Profile</span>
      <div className="mobileNavLinks" style={{display : showNavs ? "flex" : "none"}}>
        <span className='navs'> <Link activeClass='active' to="about" spy={true} offset={off} duration={dur} onClick={mobileMenuView}> About </Link> </span>
        <span className='navs'> <Link activeClass='active' to="skills" spy={true} offset={off} duration={dur} onClick={mobileMenuView}> Skills </Link> </span>
        <span className='navs'> <Link activeClass='active' to="experience" spy={true} offset={off} duration={dur} onClick={mobileMenuView}> Experience </Link> </span>
        <span className='navs'> <Link activeClass='active' to="projects" spy={true}  offset={off} duration={dur} onClick={mobileMenuView}> Projects </Link> </span>
        <span className='navs'> <Link activeClass='active' to="education" spy={true} offset={off} duration={dur} onClick={mobileMenuView}> Education </Link> </span>
        <span className='navs'> <Link activeClass='active' to="contact" spy={true} offset={off} duration={dur} onClick={mobileMenuView}> Contact </Link> </span>
        <span className='mobileGithub' onClick={openGithub}>Github Profile</span>
      </div>
    </nav>
  )
}

export default Navbar